<template>
<div id="avatar">
    <div>
        <v-breadcrumbs :items="breadcrumbs">
            <v-icon slot="divider">forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Consultar Expediente Manifestación de Valor" class="px-1 py-1">
                    <v-card-text>

                        <v-layout align-center justify-center>
                            <v-flex xs4 style="margin-top:-30px">
                                <v-card class="mx-auto primary" height="550px" max-width="400">
                                    <v-sheet class="pa-5 primary">
                                        <v-row>

                                            <v-col cols="12" sm="10" lg="10" class="pa-0 ps-3">
                                                <v-text-field style="width:380px;" v-model="search" label="Pedimento, No. Manifestación, eDoc, Cove, Nombre Proceso"
                                                    v-on:keyup.enter="buscar()" dark text solo-inverted hide-details clearable
                                                    clear-icon="mdi-close-circle-outline" hint="Pedimento, No. Manifestación, Nombre Proceso, eDoc, Cove."
                                                    title="Pedimento, No. Manifestación, Nombre Proceso, eDoc, Cove."
                                                    ></v-text-field>

                                            </v-col>
                                            <v-col cols="12" sm="2" lg="2" class="pa-0 ps-2 pt-1">
                                                <v-btn icon dark title="Pegar Listado" @click="dialog1 = !dialog1" v-tippy>
                                                    <v-icon colorHover="secondary" color="white" size="48">mdi-clipboard-list-outline</v-icon>
                                                </v-btn>
                                            </v-col>
                                        </v-row>

                                        <v-dialog v-model="dialog1" max-width="500px">
                                            <v-card>

                                                <v-card-text>
                                                    <h5>Ingrese lista de archivos</h5>
                                                    <small><b>Consulta máxima de 15 pedimentos</b></small>
                                                    <v-textarea outlined rows="15" v-model="listado"></v-textarea>
                                                </v-card-text>
                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn small @click="listado=''; dialog1 = false">Cancelar</v-btn>
                                                    <v-btn small color="primary" @click="buscar(listado); dialog1 = false">Buscar</v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                    </v-sheet>
                                    <v-card-text>
                                        <div class="tree">
                                            <div class="contenido">
                                                <v-treeview v-model="tree" :items="items" active-class="secondary lighten-4 indigo--text" :active.sync="active" activatable @update:active="preview" returnObject dense :open-all="items.length==1" :key="key">
                                                    <template v-slot:prepend="{ item, open }">
                                                        <v-icon v-if="item.file == 'folder' || item.file == 'grupo' ">{{ open ? 'mdi-folder-open' : 'mdi-folder' }}</v-icon>
                                                        <v-icon v-else>{{ files[item.file.toUpperCase()]?files[item.file.toUpperCase()]:'mdi-file' }}</v-icon>
                                                    </template>
                                                </v-treeview>
                                            </div>
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <v-flex xs8 style="margin-top:-30px">
                                <v-card class="mx-auto primary" height="550px" :key="search" v-if="active.length > 0">
                                    <v-card-title class="primary white--text">
                                        <v-icon v-if="active[0].dir != '/'" small class="white--text">search</v-icon>&nbsp;
                                        <span class="subheading">
                                            <strong v-if="active[0].dir != '/'">Vista Previa{{file}}</strong>
                                            <strong v-if="active[0].dir == '/'">Manifestación de Valor <br />{{active[0].name}}</strong>

                                        </span>
                                        <v-spacer></v-spacer>
                                        <v-btn v-if="active[0].dir == '/'" rounded color="secondary" x-small @click="adjuntar=!adjuntar;" title="Adjuntar Archivos" v-tippy>
                                            <v-icon v-if="adjuntar" small>mdi-folder-open</v-icon><v-icon v-if="!adjuntar" small>mdi-folder</v-icon>&nbsp;&nbsp; Adjuntar Archivos
                                        </v-btn>
                                    </v-card-title>
                                    <div v-if="adjuntar && active[0].dir == '/'" class="pa-10" >
                                    <v-card >
                                        <v-card-text>
                                            <v-card-text>
                                                <v-form ref="form" lazy-validation>
                                                    <v-container grid-list-md>
                                                        <v-layout wrap>
                                                            <v-flex xs12>
                                                                <v-text-field label="Selecciona el archivo ZIP" @click='pickFile' v-model='name_file' :rules="[rules.required]" :readonly="true" prepend-icon='attach_file'></v-text-field>
                                                                <input type="file" style="display: none" ref="file_input" accept=".zip" @change="onFilePicked">
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-container>
                                                </v-form>
                                            </v-card-text>
                                            <v-card-actions>
                                                <v-spacer></v-spacer>

                                            </v-card-actions>
                                        </v-card-text>
                                    </v-card>
                                  </div>
                                    <v-card-text v-if="active[0].dir != '/'">
                                        <br />

                                        <table class="table table-condensed white--text">
                                            <tbody>
                                                <tr>

                                                    <td>
                                                        <span id="lab_title_file">Archivo:</span>
                                                        <strong>
                                                            <span id="lab_file"> {{active[0].name}}</span>
                                                        </strong>
                                                    </td>

                                                    <td style="padding-top:10px !important;">

                                                        <v-btn v-if="active[0].file != 'grupo'" rounded color="green" x-small @click="download" title="Descargar" v-tippy>
                                                            <v-icon small>mdi-download</v-icon>&nbsp;&nbsp;Descargar
                                                        </v-btn>
                                                        <v-btn v-if="active[0].dir.search('/adjuntos/') > 0" rounded color="red" x-small @click="confirm=true" title="Eliminar" v-tippy>
                                                            <v-icon small>mdi-delete</v-icon>&nbsp;&nbsp;Eliminar
                                                        </v-btn>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <div v-if="active[0].file.toUpperCase() =='XML' || active[0].file.toUpperCase() =='TXT' ||  parseInt(active[0].file)  > 0  || active[0].file.toUpperCase()  =='ERR'" class="global">
                                            <div class="contenidotxt">
                                                <pre>{{xmlContent}} </pre>
                                            </div>
                                        </div>

                                        <div id="app" v-if="( active[0].file.toUpperCase() =='PDF') && url!='' ">
                                            <PDFViewer v-bind="{url}" @document-errored="onDocumentErrored"></PDFViewer>
                                        </div>
                                        <div v-if="active[0].file.toUpperCase() =='JPG' || active[0].file.toUpperCase() =='JPEG'" class="global">
                                            <div class="contenido">
                                                <v-img :src="`data:image/jpg;base64,${url}`" max-width="900px"></v-img>
                                            </div>

                                        </div>
                                        <div v-if="active[0].file.toUpperCase() =='PNG'" class="global">
                                            <div class="contenido">
                                                <v-img :src="`data:image/png;base64,${url}`" max-width="900px"></v-img>
                                            </div>

                                        </div>
                                        <v-alert border="top" colored-border type="info" elevation="2" v-if="active[0].file.toUpperCase() !='PDF'
                                        && active[0].file.toUpperCase()  !='XML' && active[0].file.toUpperCase()  !='PNG' && active[0].file.toUpperCase()  !='JPG' && active[0].file.toUpperCase()  !='JPEG' && active[0].file.toUpperCase()  !='TXT'
                                        && active[0].file !=''  && !parseInt(active[0].file)>0  && active[0].file.toUpperCase()  !='ERR' ">Vista previa no disponible.
                                        </v-alert>

                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </base-material-card>
                <v-dialog v-model="confirm" persistent max-width="490" >
                                                            <v-card>
                                                                <v-card-title class="headline" >Confirme la operación</v-card-title>
                                                                <v-card-text>¿Realmente desea eliminar el archivo adjunto del expediente?</v-card-text>
                                                                <v-card-actions>
                                                                    <v-spacer></v-spacer>
                                                                    <v-btn color="red  darken-1" text @click="confirm = false" >No</v-btn>
                                                                    <v-btn color="green darken-1" text @click="eliminar()" >Si</v-btn>
                                                                </v-card-actions>
                                                            </v-card>
                                                        </v-dialog>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import {
    request
} from "http";
import {
    mapState
} from "vuex";
import axios from "axios";
import PDFViewer from "@/components/pdf/PDFViewer.vue";
import beautify from "xml-beautifier";

export default {
    components: {
        PDFViewer
    },

    mounted() {},
    methods: {
        base64ToArrayBuffer: function (base64) {
            var binaryString = window.atob(base64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            return bytes;
        },
        preview() {
            // Para eliminar todo el expediente
            this.borrableExpediente = false;
            if (this.active.length > 0 && Number.isInteger(this.active[0].id) && this.active[0].file == "folder") {
                this.borrableExpediente = true;
            }

            this.borrable = !this.active.length || this.active[0].dir.indexOf('adjuntos') > 0 && this.active[0].file != "zip" && this.active[0].file != "folder";

            if (!this.active.length || this.active[0].file == "zip" || this.active[0].file == "folder") {
                return undefined;
            }

            if (this.active[0].file.toUpperCase() == "PDF" || this.active[0].file.toUpperCase() == "XML" || this.active[0].file.toUpperCase() == "PNG" || this.active[0].file.toUpperCase() == "JPG" || this.active[0].file.toUpperCase() == "JPEG" || this.active[0].file.toUpperCase() == 'TXT' || parseInt(this.active[0].file) > 0 || this.active[0].file.toUpperCase() == 'ERR') {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                this.xmlError = false;
                var datos = {
                    id: this.active[0].dir,
                    bucket: "production.econnect.ds"
                }
                this.xmlContent = "";
                var result = "";
                axios.post(this.$hostname + 's3/download/', datos)
                    .then((response) => {
                        if (typeof response.data !== 'undefined') {
                            let blob = new Blob([this.base64ToArrayBuffer(response.data)], {
                                    type: response.headers["content-type"]
                                }),
                                url = window.URL.createObjectURL(blob);
                            if (this.active[0].file.toUpperCase() == "PDF") {
                                this.url = url;
                            }
                            if (this.active[0].file.toUpperCase() == "XML") {
                                this.xmlContent = beautify(atob(response.data));
                            }
                            if (this.active[0].file.toUpperCase() == 'TXT' || parseInt(this.active[0].file) > 0 || this.active[0].file.toUpperCase() == 'ERR') {
                                this.xmlContent = atob(response.data)
                            }
                            if (this.active[0].file.toUpperCase() == "PNG" || this.active[0].file.toUpperCase() == "JPG" || this.active[0].file.toUpperCase() == "JPEG") {
                                this.url = response.data
                            }
                        } else {
                            this.url = "";

                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                                footer: '',
                            });
                        }
                        this.borrable = this.active[0].dir.indexOf('adjuntos') > 0 && this.active[0].file != "zip" && this.active[0].file != "folder";
                        this.$root.$dialogLoader.hide();
                    })
                    .catch((error) => {
                        this.url = "";
                        this.xmlContent = ""
                        if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined && error.response.data.mensaje == "Archivo no encontrado") {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                                footer: '',
                            });
                            this.$root.$dialogLoader.hide();
                        } else {
                            this.$swal({
                                type: "info",
                                title: "Importante",
                                text: "El tamaño del archivo no permite mostrarlo en el visor de documentos ¿Desea descargar el archivo?",
                                footer: "",
                                showCancelButton: true,
                                cancelButtonColor: "#d33",
                                confirmButtonColor: "#3085d6",
                                confirmButtonText: "Aceptar",
                                cancelButtonText: "Cancelar"
                            }).then(result => {
                                if (result.value) {
                                    this.downloadFileUrl(datos.id);
                                } else {
                                    this.$root.$dialogLoader.hide();
                                }
                            });
                        }
                        this.borrable = this.active[0].dir.indexOf('adjuntos') > 0 && this.active[0].file != "zip" && this.active[0].file != "folder";

                    });
            }

        },
        download() {
            if (this.active[0].file == "zip" || this.active[0].file == "folder") {
                this.generateZip(this.active[0].dir);
            } else {
                if (this.active[0].file.toUpperCase() == "XML") {
                    this.downloadFile(this.active[0].dir);
                } else {
                    try {
                        if (parseFloat(this.active[0].size) > 3.5) //Si pesa mas de 3.5MB que lo baje por url
                            this.downloadFileUrl(this.active[0].dir);
                        else
                            this.downloadFile(this.active[0].dir);
                    } catch (error) {
                        this.downloadFileUrl(this.active[0].dir);
                    }

                }
            }

        },
        eliminar(){
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let arreglo = this.active[0].dir.split("/");

            var datos = {
                    "id_manifestacion": parseInt(arreglo[2]),
                    "filename": this.active[0].id,
                    "ext": "." + this.active[0].file
            }
            axios.post(this.$hostname + 'bandeja_temporal/eliminar_adjunto_manifestacion/', datos)
                .then((response) => {

                    if (typeof response.data !== 'undefined') {

                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "El archivo se eliminó correctamente.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    this.$root.$dialogLoader.hide();
                    var mensaje = "Ocurrió un error al eliminar el archivo";
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                    this.confirm = false;
                    this.buscar();
                });
        },
        urlUpdated(url) {
            this.documentError = undefined;
            this.url = url;
        },

        onDocumentErrored(e) {
            this.documentError = e.text;
        },

        removerLineasVacias(listado) {
            var listadoSplit = this.listado.split("\n");
            var listadoSinEspacios = listadoSplit.filter(item => {
                return item.trim() != "";
            });
            return listadoSinEspacios;
        },

        buscar: function (listado="") {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            this.active = [];
            let rfc = this.$local_storage.get("rfc");

            var data = {};

            var listado_arr = this.removerLineasVacias(listado);
            if(listado!="" && listado_arr.length>0){
                data = {
                    rfc: rfc,
                    listado: listado_arr,
                };
                this.search = "";
            } else {
                if (this.search === null) {
                    this.$root.$dialogLoader.hide();
                    return false;
                }
                data = {
                    rfc: rfc,
                    busqueda: this.search,
                };
            }

            axios
                .post(this.$hostname + "vucem/edrive_manifestacion/", data)
                .then(res => {
                    var self = this;
                    self.items = [];
                    if (res.data.length > 0) {

                        res.data.forEach(function (item) {
                            var i = 1;
                            var children = [];
                            var coves = [];
                            var coves_adjuntos = [];
                            var edocuments = [];
                            var edocuments_adjuntos = [];
                            var evidencias = [];
                            var size_coves = 0;
                            var size_edocuments = 0;
                            self.key = item.id;

                            //agregar los raiz aqui
                            if (item.id_bitacora > 0) {
                                var divisiones = item.nombre_proceso.split("_");
                                children.push({
                                    id: divisiones[2],
                                    name: divisiones[2],
                                    dir: rfc + "/archivosM/bitacoras/" + item.id_bitacora + "_" + divisiones[2],
                                    file: 'txt',
                                    size: 0,
                                    expediente: false
                                });
                            }
                            if (item.path !=null && item.path.length > 0) {
                                children.push({
                                    id: item.no_pedimento + ".xml",
                                    name: item.no_pedimento + ".xml",
                                    dir: item.path + item.no_pedimento + ".xml",
                                    file: 'xml',
                                    size: 0,
                                    expediente: false
                                });
                                children.push({
                                    id: item.no_pedimento + ".pdf",
                                    name: item.no_pedimento + ".pdf",
                                    dir: item.path + item.no_pedimento + ".pdf",
                                    file: 'pdf',
                                    size: 0,
                                    expediente: false
                                });
                            }
                          /*   if(item.layout_manifestacion &&  item.layout_manifestacion != null && item.layout_manifestacion!=""){

                                children.push({
                                    id: "LAYOUT_MV.xlsx",
                                    name: "LAYOUT_MV.xlsx",
                                    //dir: rfc + "/manifestacion/" + item.id + "/" + item.id + "_LAYOUT_MV.xlsx",
                                    dir: item.layout_manifestacion,
                                    file: 'xlsx',
                                    size: 0,
                                    expediente: false
                                });
                            } */


                             //aqui va el pdf de la manifestacion
                            if(item.nombre_manifestacion !=""){

                                children.push({
                                    id: item.nombre_manifestacion,
                                    name: item.nombre_manifestacion + ".pdf",
                                    dir: rfc + "/manifestacion/" + item.id + "/" + item.nombre_manifestacion + ".pdf",
                                    file: 'pdf',
                                    size: 0,
                                    expediente: false
                                });
                            }


                            //aqui va el acuse pdf de la manifestacion
                            if (item.nombre_manifestacion !="") {
                                children.push({
                                    id: "Acuse_" + item.nombre_manifestacion + ".pdf",
                                    name:  "Acuse_" + item.nombre_manifestacion + ".pdf",
                                    dir: rfc + "/manifestacion/" + item.id + "/Acuse_" + item.nombre_manifestacion + ".pdf",
                                    file: 'pdf',
                                    size: 0,
                                    expediente: false
                                });
                            }

                            // EVIDENCIAS xml acuse acuse_pdf xml_consulta
                            if (item.nombre_manifestacion !="") {
                                evidencias.push({
                                    id: "Transmision_Envio.xml",
                                    name: "Transmision_Envio.xml",
                                    dir: rfc + "/manifestacion_valor/" + item.id + "/transmision/envio.xml",
                                    file: 'xml',
                                    size: 0,
                                    expediente: false
                                });
                            }
                             if (item.nombre_manifestacion !="") {
                                evidencias.push({
                                    id: "Transmision_Respuesta.xml",
                                    name: "Transmision_Respuesta.xml",
                                    dir: rfc + "/manifestacion_valor/" + item.id + "/transmision/respuesta.xml",
                                    file: 'xml',
                                    size: 0,
                                    expediente: false
                                });
                            }

                            if (item.nombre_manifestacion !="") {
                                evidencias.push({
                                    id: "Consulta_Envio.xml",
                                    name: "Consulta_Envio.xml",
                                    dir: rfc + "/manifestacion_valor/" + item.id + "/consulta/envio.xml",
                                    file: 'xml',
                                    size: 0,
                                    expediente: false
                                });
                            }
                            if (item.nombre_manifestacion !="") {
                                evidencias.push({
                                    id: "Consulta_Respuesta.xml",
                                    name: "Consulta_Respuesta.xml",
                                    dir: rfc + "/manifestacion_valor/" + item.id + "/consulta/respuesta.xml",
                                    file: 'xml',
                                    size: 0,
                                    expediente: false
                                });
                            }



                            if (evidencias.length > 0) {
                                children.push({
                                    id: "evidencias",
                                    name: "Evidencias Transmisión",
                                    dir: item.path + "evidencias",
                                    file: "grupo",
                                    size: 0,
                                    children: evidencias,
                                    expediente: false
                                });

                            }

                            // COVES DEL ARCHIVO M
                            let list_coves_normales = item.lista_coves.filter(a => {
                                return a.tipo != 2 && (a.estatus == 1 || a.acuse == 1);
                            });
                            let keys = [];
                            list_coves_normales.forEach(function (v) {
                                if (v.estatus == 1) {

                                    if(keys.indexOf(v.nombre + ".pdf") == -1){
                                    coves.push({
                                        id: v.nombre + ".pdf",
                                        name: v.nombre + ".pdf",
                                        dir: rfc + "/coves_manifestacion/" + v.nombre + ".pdf",
                                        file: 'pdf',
                                        size: 0,
                                        expediente: false
                                    });
                                    keys.push(v.nombre + ".pdf");
                                    }
                                    if(keys.indexOf(v.nombre + ".xml") == -1){
                                    coves.push({
                                        id: v.nombre + ".xml",
                                        name: v.nombre + ".xml",
                                        dir: rfc + "/coves_manifestacion/" + v.nombre + ".xml",
                                        file: 'xml',
                                        size: 0,
                                        expediente: false
                                    });
                                    keys.push(v.nombre + ".xml");
                                    }
                                }
                                if (v.acuse == 1) {
                                    if(keys.indexOf("Acuse_" + v.nombre + ".pdf") == -1){
                                    coves.push({
                                        id: "Acuse_" + v.nombre + ".pdf",
                                        name: "Acuse_" + v.nombre + ".pdf",
                                        dir: rfc + "/coves_manifestacion/Acuse_" + v.nombre + ".pdf",
                                        file: 'pdf',
                                        size: 0,
                                        expediente: false
                                    });
                                    keys.push("Acuse_" + v.nombre + ".pdf");
                                    }

                                }

                            });
                            if (coves.length > 0) {
                                children.push({
                                    id: "coves",
                                    name: "Coves",
                                    dir: item.path + "coves",
                                    file: "grupo",
                                    size: size_coves.toFixed(2),
                                    children: coves,
                                    expediente: false
                                });

                            }

                            // COVES ADJUNTOS
                            let list_coves_adjuntos = item.lista_coves.filter(a => {
                                return a.tipo == 2 && (a.estatus == 1 || a.acuse == 1);
                            });

                            list_coves_adjuntos.forEach(function (v) {
                                if (v.estatus == 1) {
                                     if(keys.indexOf(v.nombre + ".pdf") == -1){
                                    coves_adjuntos.push({
                                        id: v.nombre + ".pdf",
                                        name: v.nombre + ".pdf",
                                        dir: rfc + "/coves_manifestacion/" + v.nombre + ".pdf",
                                        file: 'pdf',
                                        size: 0,
                                        expediente: false
                                    });
                                    keys.push(v.nombre + ".pdf");
                                     }
                                      if(keys.indexOf(v.nombre + ".xml") == -1){
                                    coves_adjuntos.push({
                                        id: v.nombre + ".xml",
                                        name: v.nombre + ".xml",
                                        dir: rfc + "/coves_manifestacion/" + v.nombre + ".xml",
                                        file: 'xml',
                                        size: 0,
                                        expediente: false
                                    });
                                    keys.push(v.nombre + ".xml");
                                      }
                                }
                                if (v.acuse == 1) {
                                     if(keys.indexOf("Acuse_" + v.nombre + ".pdf") == -1){
                                    coves_adjuntos.push({
                                        id: "Acuse_" + v.nombre + ".pdf",
                                        name: "Acuse_" + v.nombre + ".pdf",
                                        dir: rfc + "/coves_manifestacion/Acuse_" + v.nombre + ".pdf",
                                        file: 'pdf',
                                        size: 0,
                                        expediente: false
                                    });
                                    keys.push("Acuse_" + v.nombre + ".pdf");
                                     }
                                }

                            });
                            if (coves_adjuntos.length > 0) {
                                children.push({
                                    id: "coves_adjuntos",
                                    name: "Coves Adjuntos",
                                    dir: item.path + "coves",
                                    file: "grupo",
                                    size: size_coves.toFixed(2),
                                    children: coves_adjuntos,
                                    expediente: false
                                });

                            }

                            // EDOCS NORMALES
                            let list_edocs_normales = item.lista_edocuments.filter(a => {
                                return a.tipo != 2 && (a.estatus == 1 || a.acuse == 1);
                            });

                            list_edocs_normales.forEach(function (v) {
                                if (v.estatus == 1) {
                                    edocuments.push({
                                        id: v.nombre + ".pdf",
                                        name: v.nombre + ".pdf",
                                        dir: rfc + "/edocs_manifestacion/" + v.nombre + ".pdf",
                                        file: 'pdf',
                                        size: 0,
                                        expediente: false
                                    });
                                    keys.push("Acuse_" + v.nombre + ".pdf");
                                    edocuments.push({
                                        id: v.nombre + ".xml",
                                        name: v.nombre + ".xml",
                                        dir: rfc + "/edocs_manifestacion/" + v.nombre + ".xml",
                                        file: 'xml',
                                        size: 0,
                                        expediente: false
                                    });
                                    keys.push(v.nombre + ".xml");
                                }
                                if (v.acuse == 1) {
                                    edocuments.push({
                                        id: "Acuse_" + v.nombre + ".pdf",
                                        name: "Acuse_" + v.nombre + ".pdf",
                                        dir: rfc + "/edocs_manifestacion/Acuse_" + v.nombre + ".pdf",
                                        file: 'pdf',
                                        size: 0,
                                        expediente: false
                                    });
                                    keys.push("Acuse_" + v.nombre + ".pdf");
                                }

                            });
                            if (edocuments.length > 0) {
                                children.push({
                                    id: "Edocuments",
                                    name: "Edocuments",
                                    dir: item.path + "eDocuments",
                                    file: "grupo",
                                    size: size_edocuments.toFixed(2),
                                    children: edocuments,
                                    expediente: false
                                });

                            }

                            // EDOCS ADJUNTOS
                            let list_edocs_adjuntos = item.lista_edocuments.filter(a => {
                                return a.tipo == 2 && (a.estatus == 1 || a.acuse == 1);
                            });

                            list_edocs_adjuntos.forEach(function (v) {
                                if (v.estatus == 1) {
                                    edocuments_adjuntos.push({
                                        id: v.nombre + ".pdf",
                                        name: v.nombre + ".pdf",
                                        dir: rfc + "/edocs_manifestacion/" + v.nombre + ".pdf",
                                        file: 'pdf',
                                        size: 0,
                                        expediente: false
                                    });
                                    keys.push(v.nombre + ".pdf");
                                    /*    edocuments_adjuntos.push({
                                            id: v.nombre + ".xml",
                                            name: v.nombre + ".xml" ,
                                            dir: rfc + "/edocs_manifestacion/" + v.nombre + ".xml",
                                            file: 'xml',
                                            size: 0,
                                            expediente: false
                                        }); */
                                }
                                if (v.acuse == 1) {
                                    edocuments_adjuntos.push({
                                        id: "Acuse_" + v.nombre + ".pdf",
                                        name: "Acuse_" + v.nombre + ".pdf",
                                        dir: rfc + "/edocs_manifestacion/Acuse_" + v.nombre + ".pdf",
                                        file: 'pdf',
                                        size: 0,
                                        expediente: false
                                    });
                                    keys.push( "Acuse_" + v.nombre + ".pdf");

                                }

                            });
                            if (edocuments_adjuntos.length > 0) {
                                children.push({
                                    id: "Edocuments_adjuntos",
                                    name: "Edocuments Adjuntos",
                                    dir: item.path + "eDocuments",
                                    file: "grupo",
                                    size: size_edocuments.toFixed(2),
                                    children: edocuments_adjuntos,
                                    expediente: false
                                });

                            }


                            // AJUNTOS
                        let adjuntos = [];
                        let size_adjuntos = 0;
                         if (item.adjuntos.length > 0) {
                            item.adjuntos.forEach(function (v) {
                                    v.ext = "." + v.ext;
                                    adjuntos.push({
                                        id: v.filename ,
                                        name: v.filename +  v.ext,
                                        dir: rfc + "/manifestacion_valor/" + item.id + "/adjuntos/" + v.filename + v.ext,
                                        file: v.ext.replace(".", ""),
                                        size: v.size,
                                        expediente: false
                                    });
                                    size_adjuntos += v.size;
                            });

                                children.push({
                                    id: "adjuntos",
                                    name: "Adjuntos",
                                    dir: '',
                                    file: "grupo",
                                    size: size_adjuntos.toFixed(2),
                                    children: adjuntos,
                                    expediente: false
                                });

                            }

                            self.items.push({
                                id: item.id,
                                name: item.nombre_proceso,
                                dir: '/',
                                file: "grupo",
                                size: 0,
                                children: children,
                                expediente: true
                            });

                        });
                    } else {
                        this.$swal({
                            type: "error",
                            title: "No se encontraron resultados",
                            text: "Favor de verificar",
                            footer: ""
                        });
                    }
                    this.$root.$dialogLoader.hide();
                })
                .catch(err => {
                    this.$root.$dialogLoader.hide();
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al consultar el archivo",
                        footer: err
                    });
                    console.log("Error: ", err);
                });

        },

        downloadFile: function (key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download/', datos)
                .then((response) => {

                    if (typeof response.data !== 'undefined') {

                        let blob = new Blob([this.base64ToArrayBuffer(response.data)], {
                                type: response.headers["content-type"]
                            }),
                            url = window.URL.createObjectURL(blob);

                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";

                        a.href = url;
                        var arreglo = key.split("/")
                        a.download = arreglo[arreglo.length - 1];
                        a.click();

                        a.parentNode.removeChild(a);
                        this.$root.$dialogLoader.hide();
                    } else {
                        this.$root.$dialogLoader.hide();
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    this.$root.$dialogLoader.hide();
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                });
        },

        generateZip: function (key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                key: key,
                usuario: this.$local_storage.get("id_usuario"),
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_zip/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        this.$swal({
                            type: "info",
                            title: "Generado...",
                            text: "En breve recibirás una notificación para descargar el ZIP",
                            footer: '',
                        });
                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        downloadFileUrl: function (dir) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: dir,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = "_blank";
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });

        },
        pickFile() {
            this.$refs.file_input.click()
        },

        onFilePicked(e) {
            try {
                const files = e.target.files;

                if (files[0] !== undefined) {

                    this.name_file = files[0].name;
                    this.size_file = files[0].size;
                    this.type_file = files[0].type;

                    if (this.size_file > 1000 * 1000 * 10) {
                        this.$swal({
                            type: "warning",
                            title: "¡Operación no Permitida!",
                            text: "El archivo no debe ser mayor a 10MB.",
                        });
                        this.reset();
                        return false;
                    }

                    var nombre = this.name_file.split(".");
                    var split = [];
                        this.uploadFile(files[0], nombre[0]);
                }
            } catch (error) {
                console.log(error);
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al leer el archivo. Favor de verificar que el archivo no esté dañado.",
                    footer: ""
                });
                this.reset();
            }

        },

        uploadFile: function (file, referencia) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var rfc_file = this.$local_storage.get("rfc");
            var usuario_file = this.$local_storage.get("id_usuario");
            var UID =  Math.floor(Math.random() * 9999999);
            var keyFile = rfc_file + "/adjuntosM/" +  UID + "_" + this.name_file.toUpperCase();
            var thisObj = this;
            var datos = {
                key: keyFile,
                bucket: "production.econnect.ds",
                type: this.type_file
            }


            axios.post(this.$hostname + 's3/upload_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var urlput = res.data.mensaje;
                        //console.log(urlput);
                        axios.put(urlput, file, {headers:{'Content-Type': this.type_file}})
                        .then((res) => {
                            thisObj.submitFile(keyFile);

                        })
                        .catch((error)=>{
                            this.$root.$dialogLoader.hide();
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un erro al cargar el archivo. Intente nuevamente por favor.",
                                footer: '',
                            });
                            console.log(error);
                        });

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un erro al cargar el archivo. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al cargar el archivo. Favor de comunicarse con soporte.";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                    this.$root.$dialogLoader.hide();
                });
        },

        submitFile(keyFile) {

            let rfc = this.$local_storage.get("rfc");
            let id_usuario = parseInt(this.$local_storage.get("id_usuario"));

            let formData = {
                id_manifestacion: this.active[0].id,
                rfc:rfc,
                key: keyFile,
                id_usuario: id_usuario
            };

            //axios.post('http://127.0.0.1:7000/leexml/', formData)
            axios.post(this.$hostname + 'bandeja_temporal/guardar_adjuntos_manifestacion/', formData)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {

                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "El archivo se proceso correctamente.",
                            footer: '',
                        });
                    }

                })
                .catch((error) => {
                    var msg = ''
                    var mostrar = true;
                    if (error.response != null) {
                        if (error.response.data.mensaje != null)
                            msg = error.response.data.mensaje;
                        if (error.response.data.message != null) { //Si entra aqui significa que regreso un TimeOut de Amazon Api, recibirá notificacion cuando temrine
                            mostrar = false;
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "El archivo se proceso correctamente",
                                footer: '',
                            });
                            msg = error.response.data.message;
                        }
                    }
                    if (mostrar) {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al cargar el archivo",
                            footer: msg,
                        });
                        console.log(error);

                    }

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                    this.reset();
                    this.buscar();
                });

        },
        reset() {
            const input = this.$refs.file_input;
            input.type = 'text';
            input.type = 'file';
            this.name_file = '';
        },
    },
    data: () => ({
        confirm : false,
        adjuntar: false,
        name_file: "",
        size_file: 0,
        type_file: 'application/zip',

        rules: {
            required: v => !!v || "Este campo es requerido",
        },

        fab: false,
        xmlError: false,
        xmlContent: "",
        url: "",
        file: "",
        search: null,
        key: 1,
        active: [],
        sel: null,
        URL: "",
        dialog1: false,
        confirm: false,
        confirmExpediente: false,
        confirmCarpeta: false,
        listado: "",
        files: {
             PDF: "mdi-file-pdf-box",
            PNG: "mdi-file-png-box",
            JPG: "mdi-file-jpg-box",
            TXT: "mdi-file-document-outline",
            XLS: "mdi-file-excel-box",
            XLSX: "mdi-file-excel-box",
            DOCX: "mdi-file-word-box",
            DOC: "mdi-file-word-box",
            XML: "mdi-xml",
            ZIP: "mdi-zip-box"
        },
        tree: [],
        items: [],
        borrable: false,
        borrableExpediente: false,
        borrableCarpeta: false,
        comentario: "",
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Consultar Expediente",
                disabled: true,
                to: ""
            }
        ],
    })
};
</script>

<style scoped>
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: white;
    margin-top: 0px;
}

.error {
    border: 1px solid red;
    background: pink;
    color: red;
    padding: 0.5em 3em;
    display: inline;
}

.box-shadow {
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11),
        0 5px 15px 0 rgba(0, 0, 0, 0.08);
}

.overflow-hidden {
    overflow: hidden;
}

@media print {
    body {
        background-color: transparent;
    }

    #app {
        margin: 0;
        padding: 0;
    }
}

.global {
    margin-left: 10px;
    margin-top: 20px;
    height: 432px;
    width: 100%;
    border: 1px solid #ddd;
    background-color: white;
    overflow: scroll;
}

.tree {
    margin-left: 0px;
    margin-top: -20px;
    height: 450px;
    width: 100%;
    border: 1px solid #ddd;
    background-color: white;
    overflow-y: scroll;
}

.contenido {
    padding: 5px;
    font-size: small;
    overflow: auto;
    background-color: white;
}

.contenidotxt {
    padding: 5px;
    font-size: small;
    overflow: auto;
    font-size: 14px !important;
    background-color: white;
}

.v-card__subtitle,
.v-card__text {
    line-height: 0.95rem !important;
}

.v-treeview--dense .v-treeview-node__root {
    min-height: 20px !important;
}

.table {
    font-size: 12px !important;
    margin-bottom: 20px;
}

.v-label {
    font-size: 8px !important;
}
</style>
